// src/components/about/DoctorProfile.jsx
import doctor from '../../Assets/Opimages/SridharDR.webp'
import { Link } from 'react-router-dom';

const DoctorProfile = () => (
  <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg overflow-hidden">
    <div className="md:flex">
      <div className="md:flex-shrink-0">
        <img 
          src={doctor}
          alt="Dr. Arumalla Sridhar Reddy" 
          className="h-64 w-full object-cover md:w-64"
        />
      </div>
      <div className="p-8">
        <h3 className="text-2xl font-bold text-blue-800 mb-4">
          Dr. Arumalla Sridhar Reddy
        </h3>
        <p className="text-gray-700 mb-4">
          BDS, MDS – Dental, Oral & Maxillofacial Surgeon  
          Chairman & Founder – Sridhar International Dental Hospitals
        </p>
        <p className="text-gray-600 mb-6">
          Started on 4th September 1995, Dr. Sridhar has built one of the most advanced 
          dental facilities in the country with a focus on precision, patient comfort, 
          and international standards.
        </p>
        <Link 
  to="/about-dr-sridhar" 
  className="text-blue-600 hover:underline font-medium"
>
  Know More About Dr. Sridhar →
</Link>
      </div>
    </div>
  </div>
);

export default DoctorProfile;